import config from "../../config";

const apiPartnerCenterEndpoint = config.apiPartnerCenterEndpoint;

export default apiPartnerCenterEndpoint;
